import { ChildCalculationResult, PersonalDetails } from '../Calculation/types';

interface Summary {
    childrenCurrentlyEnrolled: number;
    currentWeeklySpend: number;
    totalRemainingMonths: number;
}

export class GoogleTagManagerHelper {
    private static readonly delay = 1000;

    public addEstimationCompleteEvent(estimates: ChildCalculationResult[], personalDetails: PersonalDetails): any {
        const summary = this.summariseEvents(estimates); 

        this.addEvent("SubsidyEstimationComplete", {...summary, ...personalDetails});
    }

    public addEstimationCompleteVirtualPageViewEvent(): any {
        this.addEvent("VirtualPageview", {
            virtualPageURL: "/SubsidyEstimationCompleted",
            virtualPageTitle: "Subsidy estimation completed"  
        });
    }

    public async flush(): Promise<{}> {
        console.debug(`Waiting ${GoogleTagManagerHelper.delay}ms for tags to flush`)
        return new Promise((resolve) => {
            setTimeout(() => {
                console.debug("Done waiting for tags to flush");
                resolve();
            }, GoogleTagManagerHelper.delay);
        })
    }

    private summariseEvents(estimates: ChildCalculationResult[]): Summary {
        return {
            childrenCurrentlyEnrolled: estimates.length,
            currentWeeklySpend: estimates.reduce((total, currentEstimate) => total + currentEstimate.estimate!.totalFortnightlyCost / 2, 0),
            totalRemainingMonths: estimates.reduce((total, currentEstimate) => total + (6*12 - currentEstimate.enrolledChild.ageInMonths), 0)
        };
    }    

    private addEvent(event: string, details: {}) {
        console.debug("Adding event", event, `to datalayer (length before: ${this.ensureDataLayer().length})`);
        this.ensureDataLayer().push({
            event,
            ...details
        });
        console.debug("Datalayer after:", this.ensureDataLayer());
    }

    private ensureDataLayer(): any[] {
        const w: any = window;
        return w.dataLayer = w.dataLayer || [];
    }
}
